module.exports = __webpack_public_path__ + "static/media/exukonline_sensors.c081b658.jpg";